import React from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { useThemeContext } from './theme/ThemeContextProvider'
import CookieConsentProvider from './contexts/CookieConsentContext'
import DrawerCookieConsent from './components/Simple/DrawerCookieConsent/DrawerCookieConsent'
import AppRouter from './router'

export default function App() {
  const { theme } = useThemeContext()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CookieConsentProvider>
        <AppRouter />
        <DrawerCookieConsent />
      </CookieConsentProvider>
    </ThemeProvider>
  )
}
